import { MatchingPreviewComponent } from './preview/matching-preview.component';
import { MatchingEditComponent } from './edit/matching-edit.component';
import { MatchingAiChangePreviewComponent } from './ai-change-preview';
import { MatchingGradingComponent } from './grading/matching-grading.component';
import { MatchingReportComponent } from './report/matching-report.component';
import { MatchingAnswerComponent } from './answer';
export var MATCHING_REGISTRY = {
  edit: MatchingEditComponent,
  preview: MatchingPreviewComponent,
  'ai-change-preview': MatchingAiChangePreviewComponent,
  grading: MatchingGradingComponent,
  report: MatchingReportComponent,
  answer: MatchingAnswerComponent
};